"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteLink = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

exports.DeleteLink = styled_components_1["default"].a(_templateObject(), function (props) {
  return props.theme['@text-color'];
}, function (props) {
  return props.theme['@size-xs'];
});